<template>
  <div>
    <loading-anim :active="$store.state.loading" fullScreen></loading-anim>
    <div class="text-center p-5">
      <img class="logo" :src="getLogo"/>
    </div>
    <b-container>
      <h3 style="text-align:center;text-decoration:underline;">{{ getMetaTitle }}</h3>
      <router-view class="mt-4 pb-5"></router-view>
    </b-container>
  </div>
</template>

<script>
import layoutMixin from '@/mixins/layout.mixin'
import gtagMixin from '@/mixins/gtag.mixin'

export default {
  mixins: [layoutMixin, gtagMixin],
  components: {
    'loading-anim': () => import('@/components/utils/LoadingAnim')
  }
}
</script>

<style lang="scss">
  .logo {
    widows: auto;
    height: 40px;
    padding: 0;
    &:not(.logo-footer) {
      margin: 0 !important;
    }
  }

  .container-sm {
    max-width: 500px;
  }

  .navbar {
    padding-left: 0px;
    padding-right: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/layouts/PublicExtendedLayout.vue